export default "__VITE_ASSET__A6usFvwu__"